// أسماء موظفات "البوكسات" (الحسابات الجديدة مثل تيهان) من السيرفر - حتى
// ينضافن تلقائياً لقوائم الموظفين الثابتة (فلتر المدير، التاسكات، المصمم،
// الزبائن المحتملين...) بدون تعديل كود لكل موظفة جديدة.
import { useEffect, useState } from "react";
import { apiFetch, API_BASE } from "./apiClient";

let cached = null; // Promise<[{ username, displayName }]>

export const fetchBoxStaff = () => {
  if (!cached) {
    cached = apiFetch(`${API_BASE}/staff/box-accounts`)
      .then((res) => (res.ok ? res.json() : []))
      .catch(() => [])
      .then((list) => (Array.isArray(list) ? list : []));
    // نسمح بإعادة الجلب بعد شوية (لو المدير أضاف موظفة جديدة)
    cached.finally(() => setTimeout(() => (cached = null), 60 * 1000));
  }
  return cached;
};

export const useBoxStaff = () => {
  const [staff, setStaff] = useState([]);
  useEffect(() => {
    let alive = true;
    fetchBoxStaff().then((list) => alive && setStaff(list));
    return () => {
      alive = false;
    };
  }, []);
  return staff;
};

// يضيف أسماء موظفات البوكسات لقائمة أسماء ثابتة بدون تكرار
export const withBoxStaffNames = (names, boxStaff) => [
  ...names,
  ...boxStaff.map((s) => s.displayName).filter((n) => n && !names.includes(n)),
];
